import React from "react";

function ContactProfile({
  stateObj,
  setStateObj,
  UpdateProfile,
  setCurrentDiv,
}) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label htmlFor="mobile" className="form-label">
            Mobile:
          </label>
          <input
            readOnly
            value={stateObj.mobile}
            className="form-control"
            type="text"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Alternate Mobile:</label>
          <input
            onChange={(e) =>
              setStateObj({
                ...stateObj,
                alternatemobile: e.target.value,
              })
            }
            value={stateObj.alternatemobile}
            className="form-control"
            type="text"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Email:</label>
          <input
            readOnly
            value={stateObj.email}
            className="form-control"
            type="email"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="linkedin">Linkedin Profile:</label>
          <input
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({
                  ...stateObj,
                  linkedinprofile: e.target.value,
                });
            }}
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "e.g., https://www.linkedin.com/username"
            }
            readOnly={stateObj.activestatus !== "True"}
            value={stateObj.linkedinprofile}
            id="linkedin"
            className="form-control"
            type="text"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Instagram Profile:</label>
          <input
            type="text"
            id="instagram"
            name="instagram"
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "e.g., https://www.instagram.com"
            }
            className="form-control"
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, instaprofile: e.target.value });
            }}
            readOnly={stateObj.activestatus !== "True"}
            value={stateObj.instaprofile}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Facebook Profile:</label>
          <input
            type="text"
            id="facebook"
            name="facebook"
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "e.g., https://www.facebook.com/username"
            }
            readOnly={stateObj.activestatus !== "True"}
            className="form-control"
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({
                  ...stateObj,
                  facebookprofile: e.target.value,
                });
            }}
            value={stateObj.facebookprofile}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="websiteurl">Website / Portfolio:</label>
          <input
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, website: e.target.value });
            }}
            value={stateObj.website}
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Website url"
            }
            readOnly={stateObj.activestatus !== "True"}
            id="websiteurl"
            className="form-control"
            type="text"
          />
        </div>
      </div>
      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            UpdateProfile();
            setCurrentDiv("worktime");
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default ContactProfile;
